import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsCoffeescriptComponent } from './simple-icons-coffeescript.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsCoffeescriptComponent ],
    exports:      [ SimpleIconsCoffeescriptComponent ],
    bootstrap:    []
})
export class SimpleIconsCoffeescriptModule {}
